export const latinFonts = {
  body: '"Nunito", sans-serif',
};
